import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { IModuleLokaler, IModuleVärmeEl } from "../../types/ModuleDatas";
import { IJ11_BFData } from "../../types/BFDatas";

//todo -> make class?!
export const bfv_J11 = (): IBFModule => {
  const bfName = BFLType.BFV_J11;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData, formData: any): IBFResult => {
    try {
      let funktionsKontroller: IKontrollResultRow[] = [];
      let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
      const debug: any = {};
      let data: any = {};

      const moduleData: IModuleVärmeEl = module.data;

      formData = (formData?.data || module.bfs?.BFV_J11?.data) as IJ11_BFData | undefined;

      const nyttVärdeTermostat = formData?.harAngettNyInställning === "Ja" ? formData?.nyInställning : undefined;
      const gammaltVärdeTermostat = moduleData.termostatInställningsvärde;

      if (module?.data && globalData?.Byggnadsdata) {
        debug.BIM = {
          BIM_NormalårsTemperatur: bimHandler.normalårsTemperatur,
          BIM_NormalÅrsTemperaturTabell: bimHandler.normalårsTemperaturOmråde,
          BIM_Geof: bimHandler.G11_GeografiskJusteringsFaktor,
          BIM_ÅrligBruttoCentralVärme: bimHandler.G13_ÅrligBruttoAnvändningCentralVärme(),
          BIM_ÅrligBruttoTransmission: bimHandler.BIM_ÅrligBruttoTransmission(),
          BIM_BruttoCentralVärme_Ventilation: bimHandler.G17_BruttoEnergiVentilation(),
          BIM_Brutto_TappVarmVatten: bimHandler.G19_BruttoEnergiTappvatten,
          BIM_Brutto_LokalVärmekälla_Ventilation: bimHandler.BIM_Brutto_LokalVärmekälla_Ventilation(),
        };

        const roundData = roundHandler.getRoundData();
        const rumOchLokaler = roundData?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Lokaler)?.data as IModuleLokaler;
        //Funktionskontroll medeltemperatur
        const verksamhet = bimHandler.verksamhet;
        const rekommenderadTemperatur = bimHandler.verksamhetInfo?.RekommenderadMedelTemperatur as number;
        const zon = moduleData.betjäningsområde;

        const allTemperaturesInZon = rumOchLokaler.stickprov.filter((p) => p.zon === zon);
        const medelTemperaturIZon = allTemperaturesInZon?.length ? allTemperaturesInZon.reduce((acc, cur) => acc + cur.uppmättTemperatur, 0) / allTemperaturesInZon.length : 99;

        const avvikelseTemperaturUppmättMotRek = medelTemperaturIZon - rekommenderadTemperatur;

        debug.MedelTemperatur = { zon, medelTemperaturIZon, verksamhet, rekommenderadTemperatur, avvikelseTemperaturUppmättMotRek };

        const årligEnergiTransmission = bimHandler.G15_BruttoAnvändningTransmission();
        const systemAndel = moduleData.värmeSystemandel / 100;

        const vägledandeVerkningsgrad = module.moduleTypeId === ModuleTypeId.VarmeElVarmepump ? 2 : 1;
        const normalårsTemperatur = bimHandler.normalårsTemperaturOmråde;

        data.temperaturInfo = bimHandler.getModuleTemperatureInfo(module.name);

        if (avvikelseTemperaturUppmättMotRek > 0.49) {
          const överkonsumtionTransmissionPerGrad = globalData.System.mapSystemParametrar.BFV_J11_Överkonsumtion_Transmission_PerGrad / 100; //todo - Flytta till systemvärden i globaldata.

          const överkonsumtion = (avvikelseTemperaturUppmättMotRek * årligEnergiTransmission * systemAndel * överkonsumtionTransmissionPerGrad) / vägledandeVerkningsgrad;

          debug.Överkonsumtion = { årligEnergiTransmission, "systemAndel %": systemAndel * 100, vägledandeVerkningsgrad, överkonsumtionTransmissionPerGrad, överkonsumtion };

          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, överkonsumtion, "Värme (El)"));
        } else {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, undefined, ""));
        }

        //Absolut avvikelse
        const termostatAvikelseMotLokalgenomsnitt = Math.abs(medelTemperaturIZon - gammaltVärdeTermostat);
        if (termostatAvikelseMotLokalgenomsnitt >= 1) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, undefined, ""));
        }

        //Driftoptimeringar
        let förändringInomhustemperatur = 0;
        const normÅrsInfo = globalData.BFV_J11.normÅrsInfos.find((r) => r["Normårs °C Tabell nr"] === normalårsTemperatur);
        const normårsTemperatur = normÅrsInfo?.["Normårs °C"] ?? 0;
        const timmarPerGrad = normÅrsInfo?.["Timmar /°C"] ?? 0;
        if (nyttVärdeTermostat) {
          const e26 = (gammaltVärdeTermostat - normårsTemperatur) * timmarPerGrad; //(medelTemperaturIZon - normårsTemperatur) * timmarPerGrad;
          const e27 = (nyttVärdeTermostat - normårsTemperatur) * timmarPerGrad;
          förändringInomhustemperatur = e26 !== 0 ? (e26 - e27) / e26 : 0;
          const nyVärmebesparing = (förändringInomhustemperatur * årligEnergiTransmission * systemAndel) / vägledandeVerkningsgrad; //=(j11_förändringInomhustemperatur*j11ÅrligEnergiTransmission*j11SystemAndel)/j11VägledandeVerkningsgrad

          if (nyVärmebesparing > 0) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 1, nyVärmebesparing, "Värme (El)"));
          } else if (nyVärmebesparing < 0) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 2, -nyVärmebesparing, "Värme (El)"));
          } else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 3, undefined, ""));

          debug.NyttTermostatVärde = { nyttVärdeTermostat, e26, e27, normårsTemperatur, timmarPerGrad, förändringInomhustemperatur, nyVärmebesparing };
        }
      }

      const bH = bflHelper.bflHelper();

      return {
        bfName: BFLType.BFV_J11,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        note: "",
        debug,
        data,
      };
    } catch (err: any) {
      return {
        bfName: BFLType.BFV_J11,
        funktionsKontroller: [],
        driftOptimeringar: [],
        data: {},
        note: "",
        error: err.toString(),
        debug: { Error: err },
      };
    }
  };

  const bflSpecificPrepareData = (module: IModuleRound, bfl: IBFResult, bflForm: IBFResult | undefined) => {
    if (bflForm?.data) {
      const frmData = bflForm?.data as IJ11_BFData;
      if (frmData.harAngettNyInställning) {
        if (!bfl.data) bfl.data = {};
        const bflData = bfl.data as IJ11_BFData;
        bflData.harAngettNyInställning = frmData.harAngettNyInställning;
        bflData.nyInställning = frmData.nyInställning;
      }
    }
  };

  return { getResult, bflSpecificPrepareData, bfName };
};

const dflt = { bfv_JX: bfv_J11 };

export default dflt;
